exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".UpgradeTokenFormModal .inputContainer{display:flex;flex-direction:row;margin-bottom:1em}.UpgradeTokenFormModal .inputContainer .inputLabel{width:40%;font-weight:700;align-self:center}.UpgradeTokenFormModal .inputContainer .Select,.UpgradeTokenFormModal .inputContainer input{width:60%;margin:0}.UpgradeTokenFormModal .btnContainer{width:100%;text-align:center;padding:.5em 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/appdev/wizards/upgrade_token_form_modal.scss
// module id = 833
// module chunks = 0